import React from 'react';
import { Link } from 'react-router-dom';
import { weekColor } from '../admin/WeekNavigator';

const Ring = ({ pct, color, size = 52, stroke = 5 }) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <svg width={size} height={size} className="-rotate-90" aria-hidden="true">
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#27272a" strokeWidth={stroke} />
      <circle
        cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round"
        strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100}
        style={{ transition: 'stroke-dashoffset 700ms ease-out' }}
      />
    </svg>
  );
};

export default function ModuleProgressRings({ programmeId, modules }) {
  if (!modules?.length) return null;
  return (
    <div data-testid={`module-rings-${programmeId}`}>
      <p className="text-xs uppercase tracking-wider text-zinc-500 mb-2">Modules</p>
      <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1">
        {modules.map((m, i) => {
          const color = weekColor(i);
          return (
            <Link
              key={m.module_id}
              to={`/programmes/${programmeId}#module-${m.module_id}`}
              className="shrink-0 w-[104px] flex flex-col items-center gap-1.5 p-2 rounded-lg hover:bg-zinc-800/60 transition-colors"
              data-testid={`module-ring-${m.module_id}`}
              title={`${m.title}: ${m.completed} of ${m.total} activities done`}
            >
              <span className="relative">
                <Ring pct={m.progress_pct} color={color} />
                <span className="absolute inset-0 flex items-center justify-center text-[11px] font-semibold text-white">{m.progress_pct}%</span>
              </span>
              <span className="text-xs text-white text-center leading-tight line-clamp-2">{m.title}</span>
              <span className="text-[10px] text-zinc-500">{m.completed} of {m.total} done</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
